import type { TFunction } from "i18next";
import type { ReactNode } from "react";

import { OVERVIEW_TOUR_STEP_ID, SEGMENT_OVERVIEW_TOUR } from "./segmentOverviewTour";

import { SegmentStatusDot } from "@/features/segments/components/SegmentStatusDot";
import { SEGMENT_STATUS_CONFIG, SEGMENT_STATUSES } from "@/features/segments/constants";

export const createOverviewStepContent =
  (t: TFunction, stepIds: string[]) =>
    (id: string): ReactNode => {
      const stepKey = (part: string) => `${SEGMENT_OVERVIEW_TOUR.copyKey}.step.${id}.${part}`;
      if (id === OVERVIEW_TOUR_STEP_ID.OPEN) {
        return t(stepKey(stepIds.includes(OVERVIEW_TOUR_STEP_ID.ARCHIVE) ? "body" : "bodyNoEdit"));
      }
      if (id !== OVERVIEW_TOUR_STEP_ID.STATUSES) return t(stepKey("body"));

      return (
        <div className="flex flex-col gap-2">
          <ul className="flex flex-col gap-1.5">
            {SEGMENT_STATUSES.map((status) => (
              <li key={status} className="flex items-start gap-2">
                <SegmentStatusDot status={status} className="mt-1.5" />
                <span>
                  <strong>{t(SEGMENT_STATUS_CONFIG[status].labelKey)}</strong>: {t(stepKey(`status.${status}`))}
                </span>
              </li>
            ))}
          </ul>
          {stepIds.includes(OVERVIEW_TOUR_STEP_ID.ARCHIVE) && <p>{t(stepKey("archive"))}</p>}
        </div>
      );
    };
